// @flow

type Roles = Array<{id: string, name: string}>

type EnvRoleOptions = Array<{label: string, value: string }>

export const getEnvironmentRolesOptions = (roles:Roles): EnvRoleOptions =>
  roles.map(({ id, name }) => ({ label: name, value: id }));
